import { Inject, Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, shareReplay } from 'rxjs';
import { Environment } from '../../environment/environment.model';
import { TemplateCategoryEnum } from '../_enums/template-category.enum';
import { TemplateEntry } from '../_models/template-entry.model';

// The tenant's template catalogue, fetched once per session. A failed fetch is not
// cached: shareReplay resets on error, so the next subscriber retries.
@Injectable({
  providedIn: 'root',
})
export class TemplateCatalogService {
  private readonly httpClient = inject(HttpClient);
  private catalog$: Observable<TemplateEntry[]> | undefined;

  constructor(@Inject('env') private environment: Environment) {}

  public byCategory(category: TemplateCategoryEnum): Observable<TemplateEntry[]> {
    return this.getAll().pipe(map((all) => all.filter((t) => t.category === category)));
  }

  private getAll(): Observable<TemplateEntry[]> {
    if (!this.catalog$) {
      this.catalog$ = this.httpClient
        .get<TemplateEntry[]>(`${this.environment.apiUrl}/config/templates`)
        .pipe(shareReplay(1));
    }
    return this.catalog$;
  }
}
